import axios from "axios";
const api = "/api";

/////////////////////////////////////////////////////////////////////////////////////////
// Authentication
export const logUser = async (obj) => {
    const formData = new FormData();
    formData.append("uid", obj.uid);
    formData.append("password", obj.password);
    const data = await axios.post(`${api}/auth/login`, formData);
    console.log(data);
    return data;
}

export const logout = async () => {
    const data = await axios.get(`${api}/auth/logout`);
    window.localStorage.clear();
    return data;
}

/////////////////////////////////////////////////////////////////////////////////////////
// Images
export const getAllImages = async (obj) => {
    obj = obj || {};
        const data = await axios.get(`${api}/image/list`, {params: {uid: obj.uid , event_id: obj.eventid}});
        console.log(data);
        return data;
}

export const uploadImage = async ({files,eventid}) => {
    const formData = new FormData();
    Object.values(files).forEach((file) => {
        formData.append("files[]", file);
    });
    formData.append("event_id", eventid)
    const data = await axios.post(`${api}/image/upload`, formData);
    return data;
}

export const deleteImage = async (id) => {
    const formData = new FormData();
    formData.append("id", id);
    const data = await axios.post(`${api}/image/delete`, formData);
    return data;
}

export const voteImage = async (id) => {
    const formData = new FormData();
    formData.append("id", id);
    const data = await axios.post(`${api}/vote/addvote`, formData);
    return data;
} 

export const unVoteImage = async (id) => {
    const formData = new FormData();
    formData.append("id", id);
    const data = await axios.post(`${api}/vote/removevote`, formData);
    return data;
}

/////////////////////////////////////////////////////////////////////////////////////////
// SubEvent
export const createSubEvent = async (obj) => {
    console.log(obj);
    const formData = new FormData();
    formData.append("name", obj.name);
    formData.append("description", obj.description);
    formData.append("start_time", `${obj.startDate} ${obj.startTime}`);
    formData.append("end_time", `${obj.endDate} ${obj.endTime}`);
    const data = await axios.post(`${api}/event/add`, formData);
    return data;
}

export const getAllSubEvents = async () => {
    const data = await axios.get(`${api}/event/list`);
    return data;
}

export const deleteSubEvent = async (id) => {
    const formData = new FormData();
    formData.append("id", id);
    const data = await axios.post(`${api}/event/delete`, formData);
    return data;
}

/////////////////////////////////////////////////////////////////////////////////////////
// Developers
export const getAllDevelopers = async () => {
    const data = await axios.get(`${api}/dev/list`);
    return data;
}